module.exports = __webpack_public_path__ + "img/instagram_preto.fa90e1e7.png";